"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedContextProvider = exports.useEmbed = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const EmbedContext = (0, react_1.createContext)({
    isEmbed: false,
});
const useEmbed = () => (0, react_1.useContext)(EmbedContext);
exports.useEmbed = useEmbed;
const EmbedContextProvider = (props) => {
    const { children, ...embedProps } = props;
    const embedValue = embedProps;
    return (0, jsx_runtime_1.jsx)(EmbedContext.Provider, { value: embedValue, children: children });
};
exports.EmbedContextProvider = EmbedContextProvider;
